export const tracks = [
  {
    src: 'https://dsssp.io/tracks/BalloonPlanet_-_Cool_My_Bass_-_EX-000386_-_Master_-_114_Bpm_-_021123_-_BOV_-_EXT_-_2444.aac',
    cover:
      'https://dsssp.io/tracks/914278_ArtWork_CoolMyBass_BalloonPlanet.png_-_A_-_500X500.jpg',
    artist: 'BalloonPlanet',
    title: 'Cool My Bass'
  },
  {
    src: 'https://dsssp.io/tracks/Seth_Parson_-_Waiting_-_EX-000467_-_Master_-_92_Bpm_-_271123_-_BOV_-_EXT_-_2444.aac',
    cover:
      'https://dsssp.io/tracks/929919_Seth_Parson_-_Waiting_-_A_-_Thum.avif',
    artist: 'Seth Parson',
    title: 'Waiting'
  },
  {
    src: 'https://dsssp.io/tracks/Ran_Raiten_-_Praise_You_-_AO-001228_-_Master_V4_-_120_Bpm_-_190723_-_BOV_-_ORG_-_2444.aac',
    cover:
      'https://dsssp.io/tracks/896218_Gidon_Schocken_-_I_Owe_It_to_You_-_thumb.avif',
    artist: 'Gidon Schocken',
    title: 'I Owe It to You'
  },
  {
    src: 'https://dsssp.io/tracks/Adam_North_Simons_-_One_Of_These_Days_-_BO-000184-5_-_Master_V1a_-_124_Bpm_-_210824_-_BOV_-_ORG_-_2444.aac',
    cover:
      'https://dsssp.io/tracks/948685_Adam_Simons_-_One_of_These_Days_-_A_-_Thum.avif',
    artist: 'Adam Simons',
    title: 'Lost You'
  }
]
